<template>
    <div>
        <div class="container py-md-5">
            <div class="row align-items-center justify-content-between">
                <div class="col-md-5 order-last order-md-first">
                    <div class="row my-3">
                        <div class="col">
                            <h2 v-if="preview">
                                <span
                                    class="border badge fw-600 mb-2 p-1 d-inline-block bg-danger"
                                    >Visualizando versión BORRADOR</span
                                >
                            </h2>
                            <p
                                v-if="post.published_at && !post.categories.find(cat => { return cat.slug === 'producto' })"
                                class="d-inline-block fw-600 mb-1"
                            >
                                {{ formatDate(post.published_at) }}
                            </p>
                            <span v-if="post.tags !== undefined && post.tags.length > 0">
                                <div class="vr align-middle mx-3 py-3"></div>
                                <div
                                    v-for="tag in post.tags"
                                    class="border badge d-inline-block fw-600 me-2 p-1 tag-gacetilla"
                                    :key="tag.id"
                                >
                                    {{ tag.name }}
                                </div>
                            </span>
                        </div>
                    </div>
                    <h1 class="fw-600 mb-4 mb-md-5">
                        {{ post.title }}
                    </h1>
                    <span class="article-actions">
                        <span class="me-3" v-if="post.id && !post.categories.find(cat => { return cat.slug === 'producto' })">
                            <a
                                :href="apiBaseUrl + 'post/' + post.id + '/download'"
                                class="d-inline-block border-article-actions"
                                ><img
                                    src="/img/icono-flecha-download-negra.svg"
                                    height="40"
                                    alt="Descargar Todo"
                            /></a>
                            <a
                                :href="apiBaseUrl + 'post/' + post.id + '/download/pdfDocument'"
                                class="d-inline-block border-article-actions"
                                ><img 
                                    src="/img/icono-word.svg" 
                                    height="40"
                                    alt="Descargar Documento"
                            /></a>
                            <!--<a
                                href="#"
                                class="d-inline-block border-article-actions"
                                ><img src="/img/icono-sd.svg" height="40"
                            /></a>-->
                            <a
                                :href="apiBaseUrl + 'post/' + post.id + '/download/images'"
                                class="d-inline-block"
                                ><img 
                                    src="/img/icono-hd.svg" 
                                    height="40"
                                    alt="Descargar Imágenes en HD"
                            /></a>
                        </span>
                    <a class="btn btn-renault-dark" target="_blank" v-if="post.link_externo" :href="post.link_externo">
                        Ficha Técnica
                    </a>
                    </span>
                </div>
                <div class="col-md-7 p-md-3 p-0">
                    <img :src="post.coverImage" class="w-100" :alt="post.summary" />
                </div>
            </div>
            <div class="row pt-5">
                <div class="col">
                    <summary v-if="post.summary" class="fs-5 list-unstyled"><p>{{ post.summary }}</p></summary>
                    <article class="fs-5 text-justify" v-html="post.content"></article>
                </div>
            </div>
        </div>

        <FirmaPost></FirmaPost>
        
        <MediaList
            v-if="post.images !== undefined && post.images.length > 0"
            :title="'Imágenes'"
            :collection="post.images"
            :showLoadMore="false"
            @downloaded="downloadSelected"
        ></MediaList>
        <MediaList
            v-if="post.videos !== undefined && post.videos.length > 0"
            :title="'Videos'"
            :collection="post.videos"
            :showLoadMore="false"
            :showSdButton="false"
            @downloaded="downloadSelected"
        ></MediaList>
        <MediaList
            v-if="post.socialMedia !== undefined && post.socialMedia.length > 0"
            :title="'Redes Sociales'"
            :collection="post.socialMedia"
            :showLoadMore="false"
            :showSdButton="false"
            @downloaded="downloadSelected"
        ></MediaList>
        <PostPager v-if="Object.keys(post).length > 0" :post="post"></PostPager>
        <FooterPrensa></FooterPrensa>
    </div>
</template>

<script>
import MediaList from "../components/MediaList.vue";
import FooterPrensa from "../components/FooterPrensa.vue";
import PostPager from "../components/PostPager.vue";
import CardPrensa from '../components/CardPrensa.vue';
import FirmaPost from '../components/FirmaPost.vue';

export default {
    components: { MediaList, FooterPrensa, PostPager, CardPrensa, FirmaPost },
    props: {
        preview: {
            type: Boolean,
            default: false
        },
        token: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            post: {},
            selectedItems: [],
            apiBaseUrl: process.env.MIX_API_URL,
        };
    },
    metaInfo() {
        return {
            title: this.post.title,
            meta: [
                {
                    name: "description",
                    content: this.post.summary?.slice(0, 150),
                },
                {
                    property: "og:title",
                    content: this.post.title,
                },
                {
                    property: "og:description",
                    content: this.post.summary?.slice(0, 150),
                },
            ],
        };
    },
    mounted() {

    },
    created() {
        this.getPost(this.$route.params.slug);
    },
    methods: {
        getPost: function (slug) {
            const endpoint = this.preview ? 'preview/' : 'post/';
            const url = process.env.MIX_API_URL + endpoint + slug;
            
            const config = {};
            if (this.token) {
                config.params = { token: this.token };
            }
            
            axios
                .get(url, config)
                .then((response) => {
                    this.post = response.data.data;
                })
                .catch((error) => {
                    if (error.response && error.response.status === 401) {
                        // Redirect to home if not authenticated for preview
                        window.location.href = '/';
                    }
                });
        },
        formatDate: function (date) {
            const options = { year: "numeric", month: "long", day: "numeric" };
            return new Date(date).toLocaleDateString("es", options);
        },
        downloadAll: function () {
            window.location.href =
                process.env.MIX_API_URL + "post/" + this.post.id + "/download";
        },
        downloadSelected: function ({ uuids, conversion }) {
            console.log(uuids);
            console.log(conversion);
            this.selectedItems = uuids;
            let urlParams = "";
            if (this.selectedItems.length > 0) {
                urlParams = urlParams.concat(
                    "&uuids=" + JSON.stringify(this.selectedItems)
                );
            }
            if (conversion !== "") {
                urlParams = urlParams.concat("&conversion=" + conversion);
            }
            window.location.href =
                process.env.MIX_API_URL + "media/download?" + urlParams;
        },
    },
    watch: {
        $route(to, from) {
            this.getPost(this.$route.params.slug);
        },
    },
};
</script>
